/**
 * Returns the Google Forms embed URL for an activity, or null if not available.
 * Only returns a URL when sync is active AND the URL is a proper published
 * respondent URL (contains /d/e/ path). Edit URLs and short links are rejected.
 */
export function getFormEmbedUrl(activity) {
  const sync = activity?.forms_sync;
  if (!sync || sync.sync_status !== 'active') return null;

  // Only the properly resolved respondent URL (from Forms API) is safe to embed.
  // Edit URLs (/d/FORM_ID/edit) return 401; short links (forms.gle) don't embed.
  const url = sync.respondent_url || '';

  // Must be a published respondent URL — Google's format is always /d/e/...
  if (!url || !url.includes('/d/e/')) return null;

  const base = url.split('?')[0].split('#')[0];
  return `${base}?embedded=true`;
}
